import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import type { ReactNode } from "react";
import styled from "styled-components";
import { Store, Users } from "lucide-react";
import { PortfolioStatus } from "src/view/conponents/list/PortfolioIdentity";
import type { TargetType } from "./trafficAssignmentsData";

export interface TrafficEntity { id: number; name: string; status?: string; country?: string; domain?: string }

const Identity = styled.div`
	display: flex; align-items: flex-start; gap: 8px; min-width: 0; color: #344054;
	&[data-variant="assignment"] { gap: 20px; }
	.type-icon { display: grid; place-items: center; width: 34px; height: 34px; flex: 0 0 34px; color: #344054; }
	.country-flag { display: block; width: 28px; height: 18px; flex: 0 0 28px; margin-top: 2px; object-fit: cover; border-radius: 3px; box-shadow: 0 0 0 1px #b7c3cf; }
	&[data-variant="assignment"] .country-flag { width: 26px; height: 18px; flex-basis: 26px; margin-top: 0; }
	.identity-body { min-width: 0; }
	.identity-title { display: flex; align-items: center; flex-wrap: wrap; min-height: 20px; gap: 5px 8px; }
	.identity-name { font-size: 13px; font-weight: 600; line-height: 1.45; overflow-wrap: anywhere; }
	.severity { padding: 1px 7px; border-radius: 5px; font-size: 12px; font-weight: 500; line-height: 1.45; white-space: nowrap; }
	.identity-id { display: block; margin-top: 3px; color: #667085; font-size: 11px; font-weight: 400; font-variant-numeric: tabular-nums; }
`;

export const TrafficEntityItem = ({ type, id, name, status, country, badges, variant = "default" }: {
	type: TargetType; id: number; name: ReactNode; status?: string; country?: string; badges?: ReactNode; variant?: "default" | "assignment";
}) => {
	useLocale();
	const region = country?.trim().toUpperCase() === "UK" ? "GB" : country?.trim().toUpperCase();
	const flag = (type === "client" || type === "merchant") && region && /^[A-Z]{2}$/.test(region) ? <img className="country-flag" src={`https://flagcdn.com/${region.toLowerCase()}.svg`} alt="" loading="lazy" /> : null;
	const Icon = type === "merchant" ? Store : Users;
	return <Identity data-variant={variant}>
		{variant === "assignment" && <span className="type-icon"><Icon size={21} /></span>}
		{variant === "default" && flag}
		<div className="identity-body"><div className="identity-title">{variant === "assignment" && flag}<span className="identity-name">{name}</span>{status && <PortfolioStatus status={status} />}{badges}</div><span className="identity-id">{msg("id")}{id}</span></div>
	</Identity>;
};
